// extracted by mini-css-extract-plugin
export default {"PolicyEngineDetailsTable":"TKM_M0MJhnU9RyIIYo4I","PolicyEngineFootPrintContainerTable":"IWk5enbJu5h9ZRBtrXen"};